import { all, call, put, takeLatest } from "redux-saga/effects";
import {
    getCustomerLinesErrorAction,
    getCustomerLinesSuccessAction,
    GetNoteErrorAction,
    GetNoteSuccessAction,
    getNumberByCustomerIdErrorAction,
    getNumberByCustomerIdSuccessAction,
    saveNoteErrorAction, saveNoteSuccessAction, SearchNumberErrorAction, SearchNumberSuccessAction, UpdateStarErrorAction, UpdateStarSuccessAction,
}
    from "../../actions/secreteryMessageAction";

import { Types } from "../../types";
import { GetCustomerLinesResponse, GetNoteResponse, GetNumbersByCustomerIdResponse, SaveResponse, setStartResponse } from "../../types/secreteryMessage/apiRequestType";
import { getCustomerLinesSecretary, getNote, getNumbersByCustomerId, saveNote, searchRequest, updateStarStatus } from "../apiRequests/sereteryMessageRequest";






function* searchHandler(action: any) {
    try {
        const response: { data: GetNumbersByCustomerIdResponse } = yield call(searchRequest, action.payload.params)

        yield put(
            SearchNumberSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            SearchNumberErrorAction({
                error: error.message
            })
        )
    }
}


function* getNumbersByCustomerIdHandler(action: any) {
    try {
        const response: { data: GetNumbersByCustomerIdResponse } = yield call(getNumbersByCustomerId, action.payload.params)

        yield put(
            getNumberByCustomerIdSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getNumberByCustomerIdErrorAction({
                error: error.message
            })
        )
    }
}

function* saveNoteHandler(action: any) {
    try {
        const response: { data: SaveResponse } = yield call(saveNote, action.payload.params)

        yield put(
            saveNoteSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            saveNoteErrorAction({
                error: error.message
            })
        )
    }
}
function* getNoteHandler(action: any) {
    try {
        const response: { data: GetNoteResponse } = yield call(getNote, action.payload.params)

        yield put(
            GetNoteSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            GetNoteErrorAction({
                error: error.message
            })
        )
    }
}

function* updateStarStatusHandler(action: any) {
    try {
        const response: { data: setStartResponse } = yield call(updateStarStatus, action.payload.params)

        yield put(
            UpdateStarSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            UpdateStarErrorAction({
                error: error.message
            })
        )
    }
}


function* getCustomerLinesHandler(action: any) {
    try {
        const response: { data: GetCustomerLinesResponse[] } = yield call(getCustomerLinesSecretary)

        yield put(
            getCustomerLinesSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getCustomerLinesErrorAction({
                error: error.message
            })
        )
    }
}





function* secretaryMessageSaga() {
    yield all([takeLatest(Types.SECRETARY_MESSAGE_SEARCH_REQUEST, searchHandler)]);
    yield all([takeLatest(Types.GET_NUMBER_BY_REQUEST_ID_REQUEST, getNumbersByCustomerIdHandler)]);
    yield all([takeLatest(Types.SECRETARY_MESSAGE_SAVE_REQUEST, saveNoteHandler)]);
    yield all([takeLatest(Types.SECRETARY_MESSAGE_GET_NOTE_REQUEST, getNoteHandler)]);
    yield all([takeLatest(Types.SECRETARY_MESSAGE_UPDATE_STAR_REQUEST, updateStarStatusHandler)]);
    yield all([takeLatest(Types.SECRETARY_GET_CUSTOMER_LINES_REQUEST, getCustomerLinesHandler)])
}

export default secretaryMessageSaga